module.exports = __webpack_public_path__ + "img/2.536618f9.jpg";